import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import useDropdown from "../../../../hooks/dropdown.hook";
import OpenEyeIcon from "../../../icons/open-eye-v2.icon.jsx";
import CheckIcon from "../../../icons/check.icon.jsx";
import PlusIcon from "../../../icons/plus.icon.jsx";
import SaveViewModal from "./save-view-modal";
import styles from "./MspAccountsHeader.module.scss";

const ViewSelectorDropdown = ({ viewCount }) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({});
  const [selectedOption, setSelectedOption] = useState("default-view");
  const [showSaveViewModal, setShowSaveViewModal] = useState(false);

  const dropdownOptions = [
    {
      id: "default-view",
      label: "Default View",
      isSelected: true,
      hasIcon: true,
      iconType: "check",
      textColor: "gray",
      paddingLeft: "x2",
      hasBorderTop: false,
    },
    {
      id: "my-msps",
      label: "My MSPs",
      isSelected: false,
      hasIcon: false,
      textColor: "gray",
      paddingLeft: "l8r2",
      hasBorderTop: false,
    },
    {
      id: "save-new-view",
      label: "Save New View",
      isSelected: false,
      hasIcon: true,
      iconType: "add",
      textColor: "primary",
      paddingLeft: "l3r2",
      hasBorderTop: true,
    },
  ];

  const handleOptionClick = (optionId) => {
    if (optionId === "save-new-view") {
      setShowSaveViewModal(true);
      setIsOpen(false);
    } else {
      setSelectedOption(optionId);
    }
  };

  const handleKeyDown = (event, optionId) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOptionClick(optionId);
    }
  };

  return (
    <Dropdown
      show={isOpen}
      onToggle={() => setIsOpen(prev => !prev)}
      className={styles.viewSelectorWrapper}
    >
      <Dropdown.Toggle
        ref={refBtn}
        className={styles.viewSelectorButton}
        aria-label="Select view"
        aria-haspopup="true"
        style={{
          backgroundColor: 'transparent',
          borderColor: '#EBEDF1',
          outline: 'none',
          boxShadow: 'none',
        }}
      >
        <div className={styles.viewSelectorButtonInner}>
          <OpenEyeIcon 
            width={14} 
            height={14} 
            fill="#616778"
          />
          <span className={styles.viewSelectorText}>Default View</span>
        </div>

        <div className={styles.viewSelectorCountContainer}>
          <div className={styles.viewSelectorCountInner}>
            <span className={styles.viewSelectorCount}>{viewCount}</span>

            <div className={styles.viewSelectorChevron}>
              <img
                src="/images/big-chevron-down.svg"
                alt=""
                className={styles.viewSelectorChevronIcon}
                width={6}
                height={6}
              />
            </div>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu ref={refMenu} className={styles.viewSelectorMenu} renderOnMount>
        {dropdownOptions.map((option) => (
          <div
            key={option.id}
            className={`${styles.viewSelectorMenuItem} ${
              option.paddingLeft === "x2" ? styles.viewSelectorMenuItemPaddingX2 : ""
            } ${
              option.paddingLeft === "l8r2" ? styles.viewSelectorMenuItemPaddingL8R2 : ""
            } ${
              option.paddingLeft === "l3r2" ? styles.viewSelectorMenuItemPaddingL3R2 : ""
            } ${
              option.hasBorderTop ? styles.viewSelectorMenuItemWithBorder : ""
            }`}
            role="option"
            aria-selected={option.id === selectedOption}
            tabIndex={0}
            onClick={() => handleOptionClick(option.id)}
            onKeyDown={(e) => handleKeyDown(e, option.id)}
          >
            {option.hasIcon && option.iconType === "check" && (
              <div className={styles.viewSelectorMenuItemIconContainer}>
                <CheckIcon className={styles.viewSelectorMenuItemIcon} fill="#616778" aria-hidden="true" />
              </div>
            )}

            <div className={styles.viewSelectorMenuItemTextContainer}>
              {option.hasIcon && option.iconType === "add" && (
                <div className={styles.viewSelectorMenuItemAddIconContainer}>
                  <PlusIcon 
                    className={styles.viewSelectorMenuItemIcon} 
                    fill="#008FD4" 
                    style={{ fill: '#008FD4' }}
                    aria-hidden="true" 
                  />
                </div>
              )}

              <div
                className={`${styles.viewSelectorMenuItemLabel} ${
                  option.textColor === "gray"
                    ? styles.viewSelectorMenuItemLabelGray
                    : styles.viewSelectorMenuItemLabelPrimary
                }`}
              >
                {option.label}
              </div>
            </div>
          </div>
        ))}
      </Dropdown.Menu>
      <SaveViewModal 
        show={showSaveViewModal} 
        hideModal={() => setShowSaveViewModal(false)} 
      />
    </Dropdown>
  );
};

export default ViewSelectorDropdown;